import { useSearchParams } from 'react-router-dom'
import { Chat } from '@/components/chat'

export function ActivityPage() {
  const [searchParams] = useSearchParams()
  const threadId = searchParams.get('threadId')
  const scrollTo = searchParams.get('scrollTo')
  const messageId = searchParams.get('messageId')
  const sessionId = searchParams.get('sessionId')

  const scrollToValue = messageId || (scrollTo === 'end' ? 'end' : undefined)

  return (
    <div className="flex flex-col overflow-hidden h-full">
      <Chat
        initialThreadId={threadId || undefined}
        scrollTo={scrollToValue}
        sessionId={sessionId || undefined}
      />
    </div>
  )
}
